<template>
  <div class="bordered" :class="{ rejected: asset.state == 'rejected', deleted: asset.state == 'deleted'}">

    <div class="container-fill" @click="toggle">
      <div>
        <div class="title">
          {{asset.value}} <span class="subtitle">({{ asset.type }})</span>
          <!-- {{asset.value}} -->
        </div>
      </div>
      <div class="subtitle">
        <div v-show="asset.manually_added">
          Manually added
        </div>
        <!--
        <div v-show="!asset.manually_added">
          Discovered
        </div>
        -->
      </div>
      <div class="subtitle">
        <div v-if="asset.discovery_progress != 100.0">
          Discovering {{ asset.discovery_progress }}%
        </div>
        <div v-else>
          (state: <span class="bold">{{ asset.state }}</span>, level: <span class="bold">{{ asset.level }})</span>
        </div>
      </div>
    </div>

    <div class="details" v-show="isActive">
      <table>   
        <tr>
          <td>New State:</td>
          <td>
            <select type="text" v-model="tempState">
              <option value="suggested">suggested</option>
              <option value="confirmed">confirmed</option>
              <option value="rejected">rejected</option>
              <option value="deleted">deleted</option>
            </select>
          </td>
          <td>New Level:</td>
          <td>
            <select type="text" v-model="tempLevel">
              <option value="monitoring">monitoring</option>
              <option value="continuous_testing">continuous_testing</option>
              <option value="penetration">penetration</option>
            </select>
          </td>
        </tr>
      </table>
      <button @click="cancel()">Cancel</button>
      <button @click="save()">Save</button>
      <button @click="del()">Delete</button>
      <br>
      <button @click="discover()">Discover</button>
      <button v-show="isMonitored" @click="monitor()">Monitor</button>
      <button v-show="isContinuousTesting" @click="scan()">Scan</button>
      <!-- <button v-show="isContinuousTesting" @click="jsonReport()">JSON Report</button> -->
      <button v-show="isContinuousTesting" @click="pdfReport()">PDF Report</button>

      <div>  
            <b>ID:  </b>{{ asset.id }}
            <div class="host" v-show="isHost">
              <b>OS:  </b>{{ asset.os }} <br>
              <b>Services: </b> <br>
              <li v-for="service in asset.services" :key="service.port">
                {{ service.port }}:{{ service.protocol }}
              </li>
            </div>
      </div>

      <b>Changes: </b>
      <Change v-for="change in filteredChanges" :key="change.id" :change="change"/>
      <b>Vulnerabilities: </b>
      <AssetVulnerability v-for="vulnerability in asset.vulnerabilities" :key="vulnerability.id" :vulnerability="vulnerability"/>
    </div>
      
    <pre class="debug" v-show="debugMode">{{asset}}</pre>
    
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#profileButtons {
  display: inline-block;
  float: right;
}
.default {
  font-size: small;
}
.container {
  display: flex;
}
.container-fill {
  display: flex;
  justify-content: space-between;
}
.details {
  margin-top: 5px;
  border-top: 1px solid #cccccc;
  padding-top: 5px;
}
.details-header {
  font-size: small;
}
.details-header > h2,h3,h4 {
  font-size: initial;
  margin: 0px;
}
.title {
  font-size: 16px;
  font-weight: bold;
}
.subtitle {
  font-size: 14px;
  font-weight: normal;
}
.bold {
  font-weight: bold;
}
.deleted {
  background-color: lightcoral;
}
.rejected {
  background-color: lightyellow;
}
</style>

<script>
import { mapState } from 'vuex'
import Change from '@/components/Change.vue'
import AssetVulnerability from '@/components/AssetVulnerability.vue'

export default {
  components: {
    Change,
    AssetVulnerability
  },
  props: {
    asset: {
      type: Object,
      required: true
    }
  },
  computed: {    
    filteredChanges() {
      // console.log('filteredChanges:', this.asset.changes)
      if (!this.asset.changes || !this.asset.changes.length) return []      
      return this.asset.changes
    },
    filteredVulnerabilities() {
      console.log('filteredVulnerabilities:', this.asset.vulnerabilities)
      if (!this.asset.vulnerabilities || !this.asset.vulnerabilities.length) return []      
      return this.asset.vulnerabilities
    },
    isDomain () {
      return this.asset.type == 'domain'
    },
    isHost () {
      return this.asset.type == 'host'
    },
    isMonitored () {
      if (this.asset.type == 'domain' || this.asset.type == 'iprange') return false
      return true
    },
    isContinuousTesting () {
      if (this.asset.level != 'continuous_testing') return false
      return true
    },
    ...mapState([
      'debugMode'
    ])
  },
  data () {
    
    return {             
          isActive: false,
          tempState: this.asset.state,
          tempLevel: this.asset.level
          //profileName: this.profile.name      
        }      
    
  },  
  methods: {
    toggle: function (event) {
      if (event.target.tagName != 'DIV' && event.target.tagName != 'SPAN') return
      this.isActive = !this.isActive
      if(this.isActive) {
        this.$store.dispatch('loadAsset', {
            profile: this.profile, 
            //params: params,
            asset: this.asset
          })
      }
    },
    cancel () {
      this.tempState = this.asset.state
      this.tempLevel = this.asset.level
    },
    save () {
      var params = {
            state: this.tempState,
            level: this.tempLevel
          }
      //Call API to update
        this.$store.dispatch('updateAsset', {
          profile: this.profile, 
          params: params,
          asset: this.asset
        })
        this.asset.state = this.tempState
        this.asset.level = this.tempLevel
    },    
    discover () {
      this.$store.dispatch('discoverAsset', {
        profile: this.profile, 
        asset: this.asset
      })
    },
    monitor () {
      this.$store.dispatch('monitorAsset', {
        profile: this.profile, 
        asset: this.asset
      })
    },
    scan () {
      this.$store.dispatch('scanAsset', {
        profile: this.profile, 
        asset: this.asset
      })
    },
    del () {
      if (!confirm('Are you sure? This will delete the asset!')) return
      this.$store.dispatch('deleteAsset', {
        profile: this.profile, 
        asset: this.asset
      })
    },
    jsonReport () {
      this.$store.dispatch('jsonReport', {
        profile: this.profile, 
        asset: this.asset
      })
    },
    pdfReport () {
      this.$store.dispatch('pdfReport', {
        profile: this.profile, 
        asset: this.asset
      })
    }
  }
}
</script>
